import angular from "angular";
import template from "./batch-create-entity.html";
import InstructorBatchCreateController from "./batch-create-entity.controller";
import CreateShiftModalInstanceController from "./create-shift.controller";
function dcInstructorBatchCreate() {
  return {
    restrict: "E",
    scope: {
      entity: "@",
      context: "@",
    },
    template: template,
    link: (scope, element, attrs) => {},
    controller: InstructorBatchCreateController,
    controllerAs: "vm",
    bindToController: true,
  };
}

export default angular
  .module("instructor.directives.batchcreate", [])
  .controller(
    "dcInstructorBatchCreateController",
    InstructorBatchCreateController,
  )
  .controller(
    "InstructorCreateShiftModalInstanceController",
    CreateShiftModalInstanceController,
  )
  .directive("dcInstructorBatchCreate", dcInstructorBatchCreate);

